// zoom animation on scroll 

class AnimatedHeroImage {
  constructor(img, container) {
    this.img = img;
    this.container = container;
    this.startScale = 1;  
    this.endScale = 1.0936; 

    this.onScroll = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    const containerTop = this.container.getBoundingClientRect().top;

    if (containerTop <= 0) {
      this.img.style.transform = `scale(${this.startScale})`;
    } else {
      this.img.style.transform = `scale(${this.endScale})`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.zoom-section');
  containers.forEach(container => {
    const images = container.querySelectorAll('.zoom-img');
    images.forEach(img => {
      new AnimatedHeroImage(img, container);
    });
  });
});